/**
 * What a screen shows while a state's rules are on their way (packages/core/src/states/loaders.ts), or when they could not
 * be fetched. Never a blank, never another state's rules: a short skeleton and a line, or the reason and Try again.
 */
import { stateName, type UsState } from "@logwave/core";
import { ErrorBox, Skeleton } from "./ui.tsx";

export function StateLoadingCard({ state, status, onRetry }: { state: UsState; status: "loading" | "failed"; onRetry(): void }) {
  const name = stateName(state);
  if (status === "failed") return <div data-testid="state-load-failed"><ErrorBox error={`We couldn't load the ${name} rules. Check your connection, then try again.`} onRetry={onRetry} /></div>;
  return (
    <div data-testid="state-loading">
      <Skeleton rows={2} label={`Loading the ${name} rules`} />
      <p className="caption">{`Loading the ${name} rules…`}</p>
    </div>
  );
}
